import { useState } from 'react';
import { Switch } from '@mui/material';
import { FreeTrialModal } from './FreeTrialModal';
import { useEnableCheckoutFreeTrialMutation } from '../../../../generated/graphql';
import toast from 'react-hot-toast';

export const FreeTrialToggle = ({
  influencerId,
  enableCheckoutFreeTrial,
}: {
  influencerId: number;
  enableCheckoutFreeTrial: boolean;
}) => {
  const [isTrialEnabled, setTrialEnabled] = useState(enableCheckoutFreeTrial);
  const [openModal, setOpenModal] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const [enableCheckoutFreeTrialMutation] =
    useEnableCheckoutFreeTrialMutation();
  const onSubmit = async () => {
    setSubmitting(true);
    return await enableCheckoutFreeTrialMutation({
      variables: {
        data: {
          influencerId,
          isEnabled: !isTrialEnabled,
        },
      },
    })
      .then(() => {
        toast.success(
          isTrialEnabled
            ? '7-Day Free Trial has been successfully disabled.'
            : '7-Day Free Trial is now available for your subscribers!',
        );
        setTrialEnabled((prev) => !prev);
      })
      .catch(() => {
        toast.error('Something went wrong!');
      })
      .finally(() => {
        setOpenModal(false);
        setSubmitting(false);
      });
  };

  return (
    <>
      <Switch checked={isTrialEnabled} onChange={() => setOpenModal(true)} />
      <FreeTrialModal
        open={openModal}
        toggle={() => setOpenModal((prev) => !prev)}
        onSubmit={onSubmit}
        isTrialEnabled={isTrialEnabled}
        isSubmitting={isSubmitting}
      />
    </>
  );
};
